

export default function PhoneNumber(params){

    return(
                    <div>
                        <h3>Phone:</h3>
                        <a href="callto:8013729613">(435) 314-8330</a>
                    </div>
    )
}